// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__GyUgF","msg":"Message_msg__tVA2w","msgVideo":"Message_msgVideo__CVBwm","borderVideo":"Message_borderVideo__VSQjo","fadeMask":"Message_fadeMask__pqYNM"};